import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadingStatus } from "../lib/types";
import { PURGE } from "redux-persist";

const name = "main";

export type SearchOption = {
  keyword: string;
  sort: string;
  order: string;
  stages: number[];
  isShowFree: boolean;
  selectMonth: number;
};

export type SearchOptionWithComplete = {
  keyword: string;
  sort: string;
  order: string;
  status: number[];
  isShowComplete: boolean;
  selectMonth: number;
  isShowFree: boolean;
};

export type MainState = {
  loadingStatus: number;
  searchOption: SearchOption;
  searchTotalOption: SearchOption;
  searchTaxOption: SearchOptionWithComplete;
  searchInvoiceOption: SearchOptionWithComplete;
  searchRepositOption: SearchOptionWithComplete;
  schoolYears: number[];
  salesYears: number[];
  taxYears: number[];
  dashboardYear: number;
};

const initialState: MainState = {
  loadingStatus: LoadingStatus.NONE,
  searchOption: {
    keyword: "",
    sort: "date",
    order: "asc",
    // 필터 추가시
    stages: [0, 5, 6, 7],
    isShowFree: false,
    selectMonth: 0,
  },
  searchTotalOption: {
    keyword: "",
    sort: "date",
    order: "asc",
    // 필터 추가시
    stages: [0, 5, 6, 7],
    isShowFree: false,
    selectMonth: 0,
  },
  searchTaxOption: {
    keyword: "",
    sort: "date",
    order: "asc",
    // 필터 추가시
    status: [5, 6, 7],
    isShowComplete: false,
    selectMonth: 0,
    isShowFree: false,
  },
  searchInvoiceOption: {
    keyword: "",
    sort: "date",
    order: "asc",
    // 필터 추가시
    status: [],
    isShowComplete: false,
    selectMonth: 0,
    isShowFree: false,
  },
  searchRepositOption: {
    keyword: "",
    sort: "date",
    order: "asc",
    // 필터 추가시
    status: [],
    isShowComplete: false,
    selectMonth: 0,
    isShowFree: false,
  },
  schoolYears: [2026],
  salesYears: [2026],
  taxYears: [2026],
  dashboardYear: 2026,
};

export const mainSlice = createSlice({
  name,
  initialState,
  reducers: {
    setSearchStatus: (state, action: PayloadAction<SearchOption>) => {
      state.searchOption = action.payload;
    },
    setSearchTotalStatus: (state, action: PayloadAction<SearchOption>) => {
      state.searchTotalOption = action.payload;
    },
    setSearchTaxStatus: (
      state,
      action: PayloadAction<SearchOptionWithComplete>
    ) => {
      state.searchTaxOption = action.payload;
    },
    setSearchInvoiceStatus: (
      state,
      action: PayloadAction<SearchOptionWithComplete>
    ) => {
      state.searchInvoiceOption = action.payload;
    },
    setSearchRepositStatus: (
      state,
      action: PayloadAction<SearchOptionWithComplete>
    ) => {
      state.searchRepositOption = action.payload;
    },
    setSchoolYears: (state, action: PayloadAction<number[]>) => {
      state.schoolYears = action.payload;
    },
    setSalesYears: (state, action: PayloadAction<number[]>) => {
      state.salesYears = action.payload;
    },
    setTaxYears: (state, action: PayloadAction<number[]>) => {
      state.taxYears = action.payload;
    },
    setDashboardYear: (state, action: PayloadAction<number>) => {
      state.dashboardYear = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const {
  setSearchStatus,
  setSearchTotalStatus,
  setSearchTaxStatus,
  setSearchInvoiceStatus,
  setSearchRepositStatus,
  setSchoolYears,
  setSalesYears,
  setTaxYears,
  setDashboardYear,
} = mainSlice.actions;

export default mainSlice.reducer;
